import {
  getObject,
  getString,
} from "@surya-digital/leo-ts-types";
import { BasicQuestionDetails, BasicQuestionDetailsDTO } from "./basicQuestionDetails";
import { JsonVersion, JsonVersionDTO } from "./jsonVersion";

export interface QuestionDetailsDTO {
  basicQuestionDetails: BasicQuestionDetailsDTO;
  questionDetailsJSON: string;
  jsonVersion: JsonVersionDTO;
}

export class QuestionDetails {
  readonly isQuestionDetailsQuestionDetails: boolean = true;

  readonly basicQuestionDetails: BasicQuestionDetails;
  readonly questionDetailsJSON: string;
  readonly jsonVersion: JsonVersion;


  constructor(
  basicQuestionDetails: BasicQuestionDetails, 
  questionDetailsJSON: string, 
  jsonVersion: JsonVersion
  ) {
    this.basicQuestionDetails = basicQuestionDetails;
    QuestionDetails.validateQuestionDetailsJson(questionDetailsJSON);
    this.questionDetailsJSON = questionDetailsJSON;
    this.jsonVersion = jsonVersion;
  }

  static fromDTO(dto: QuestionDetailsDTO): QuestionDetails {
    const basicQuestionDetails = BasicQuestionDetails.fromDTO(getObject(dto, "basicQuestionDetails", InvalidQuestionDetailsBasicQuestionDetailsError));
    const questionDetailsJSON = getString(dto, "questionDetailsJSON", InvalidQuestionDetailsQuestionDetailsJsonError);
    const jsonVersion = JsonVersion.fromDTO(getObject(dto, "jsonVersion", InvalidQuestionDetailsJsonVersionError));
    return new QuestionDetails(
      basicQuestionDetails,
      questionDetailsJSON,
      jsonVersion
    );
  }

  toDTO(): QuestionDetailsDTO {
    const dto: QuestionDetailsDTO = {
        basicQuestionDetails: this.basicQuestionDetails.toDTO(),
        questionDetailsJSON: this.questionDetailsJSON,
        jsonVersion: this.jsonVersion.toDTO()
    };
    return dto;
  }
  private static validateQuestionDetailsJson = (questionDetailsJSON: string): void => {
    if(questionDetailsJSON.trim().length === 0) {
      throw new InvalidQuestionDetailsQuestionDetailsJsonNonEmptyError(
        `Attribute questionDetailsJSON cannot be an empty string.`
      );
    }
  }
  
}

QuestionDetails.prototype.toString = function toString(): string {
  return `QuestionDetails(basicQuestionDetails='${this.basicQuestionDetails}',questionDetailsJSON='${this.questionDetailsJSON}',jsonVersion='${this.jsonVersion}')`;
};

export class InvalidQuestionDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionDetailsError";
  }
}
export class InvalidQuestionDetailsBasicQuestionDetailsError extends InvalidQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionDetailsBasicQuestionDetailsError";
  }
}

export class InvalidQuestionDetailsQuestionDetailsJsonError extends InvalidQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionDetailsQuestionDetailsJsonError";
  }
}

export class InvalidQuestionDetailsQuestionDetailsJsonNonEmptyError extends InvalidQuestionDetailsQuestionDetailsJsonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionDetailsQuestionDetailsJsonNonEmptyError";
  }
}

export class InvalidQuestionDetailsJsonVersionError extends InvalidQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionDetailsJsonVersionError";
  }
}
